import { Cirus } from "@/classes/Http";
enum FeatureType {
    TEXT = "text",
    SELECT = "select",
    NUMBER = "number",
    COLOR = "color",
}

class UpdateProductFeatureBody {
    feature_id?: string;
    filter_id: string
    category_id: string
    type?: FeatureType = FeatureType.TEXT;
    value: any;
}

export class BatchUpdateProductFeatureBody {
    features: UpdateProductFeatureBody[];
}
export function updateProductFeatures(instance_id: number, product_id: string, params: BatchUpdateProductFeatureBody) {
    const path = `/instance/${instance_id}/product/${product_id}/features`;
    return Cirus.post(path, {features: params});
}